// Merkezi statik veri dosyası - Çoklu Dil Desteği
// Bu dosyadan tüm statik verileri yönetebilirsiniz

// Çoklu dil içerikleri
export const content = {
  tr: {
    // Hizmetler
    services: [
      {
        ID: 1,
        OrderNo: "01",
        IconName: "flaticon-worker",
        ServiceName: "Üretim Danışmanlığı",
        ServiceContent: "Üretim süreçlerinizi optimize ediyor, verimliliğinizi artırıyoruz."
      },
      {
        ID: 2,
        OrderNo: "02",
        IconName: "flaticon-factory-1",
        ServiceName: "Tesis Kurulumu",
        ServiceContent: "Modern ve verimli üretim tesisleri kuruyoruz."
      },
      {
        ID: 3,
        OrderNo: "03",
        IconName: "flaticon-settings",
        ServiceName: "Makine Mühendisliği",
        ServiceContent: "Özel makine tasarımı ve imalatı hizmetleri sunuyoruz."
      },
      {
        ID: 4,
        OrderNo: "04",
        IconName: "flaticon-gear",
        ServiceName: "Kalite Kontrol",
        ServiceContent: "Ürün kalitesini garanti altına alan kontrol sistemleri."
      },
      {
        ID: 5,
        OrderNo: "05",
        IconName: "flaticon-wrench",
        ServiceName: "Bakım Hizmetleri",
        ServiceContent: "Makine ve ekipmanlarınızın düzenli bakım hizmetleri."
      },
      {
        ID: 6,
        OrderNo: "06",
        IconName: "flaticon-optimization",
        ServiceName: "Teknik Destek",
        ServiceContent: "7/24 teknik destek ve danışmanlık hizmetleri."
      },
      {
        ID: 7,
        OrderNo: "07",
        IconName: "flaticon-helicopter",
        ServiceName: "Alüminyum ve Çelik Helikopter Pistleri",
        ServiceContent: "Havaalanları ve özel tesisler için güvenli ve dayanıklı helikopter pisti çözümleri."
      }
    ],
    // Şirket bilgileri
    companyInfo: {
      name: "Maco Endüstri",
      tagline: "Yüksek Kalitede Kararlıyız",
      description: "Hammadde üretiminden, mamul ürüne uzanan bu yol haritasında özellikle enerji kullanımı, üretim hızı, kalite ve yeşil üretime uygun proseslerin oluşturulması yine şirketimiz uzmanlık konuları arasındadır.",
      address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
      phone: "0 (212) 224 41 15",
      email: "info@macomakina.com.tr",
      website: "https://macomakina.com.tr/"
    },
    // Menü öğeleri
    menu: {
      home: "Ana Sayfa",
      about: "Hakkımızda",
      services: "Hizmetlerimiz",
      products: "Ürünler",
      contact: "İletişim",
      portfolio: "Projelerimiz",
      // Alt menüler
      subMenus: {
        products: [
          { name: "PuraDyn Filtre Sistemi", link: "/urun/1" },
          { name: "PuraDyn MTS-40", link: "/urun/2" },
          { name: "PuraDYN MTS-60", link: "/urun/3" },
          { name: "PuraDYN MTS-240", link: "/urun/4" }
        ],
        services: [
          { name: "Makina Tedariği", link: "/" },
          { name: "Test Kurulumu", link: "/" },
          { name: "Danışmanlık", link: "/" }
        ]
      }
    },
    // Genel metinler
    texts: {
      ourServices: "Hizmetlerimiz",
      contactInfo: "İletişim Bilgileri",
      aboutUs: "Hakkımızda",
      readMore: "Daha Fazlası",
      address: "adres",
      phone: "telefon",
      email: "e-mail",
      projects: "Projelerimiz",
      blog: "Blog",
      testimonials: "Müşteri Yorumları",
      home: "Ana Sayfa",
      about: "Hakkımızda",
      services: "Hizmetlerimiz",
      products: "Ürünler",
      contact: "İletişim",
      portfolio: "Projelerimiz"
    },
    // Ana sayfa slider içerikleri
    homeSlider: [  {
      image: "main-slider/heliport-1.png",
      title: "Çelik ve Alüminyum Helikopter Pistleri"
    },
      {
        image: "main-slider/Maco-Banner01.png",
        title: "Alüminyum Projesine Komple Çözüm"
      },
      {
        image: "main-slider/Maco-Banner02.jpg",
        title: "Hizmette Kalite Anlayışı"
      }
    
    ],
    // İletişim sayfası içerikleri
    contact: {
      formTitle: "Bize Ulaş",
      formFields: {
        name: "İsim Soyisim",
        phone: "Telefon",
        email: "E-mail",
        message: "İletiniz"
      },
      submitButton: "Bize Ulaş",
      contactInfo: {
        addressTitle: "Şirket Adresi",
        address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
        emailTitle: "E-mail",
        phoneTitle: "Telefon Numaraları",
        emails: [
          "info@alcometal.com.tr",
          "info@macomakina.com.tr"
        ],
        phones: [
          "+90 212 224 41 15",
          "+90 212 224 41 16"
        ]
      }
    },
    // Hakkımızda sayfası içerikleri
    about: {
      pageTitle: "Hakkımızda",
      breadcrumb: {
        home: "Anasayfa",
        about: "Hakkımızda"
      },
      story: {
        label: "HİKAYEMİZ",
        title: "Türkiye Metal sektöründe",
        titleLine2: "50 yılı aşkın süredir",
        titleLine3: "hizmet veriyoruz",
        since: "since 1972",
        subtitle: "Geleceği öngören bir yapı ve tecrübe ile Alüminyum un yakın gelecekte ülkemiz için ne kadar önemli, stratejik olduğunu belirledik.",
        description: "Dünya da yapılan çalışmaları eş zamanlı takip ettik. Ülkemiz Üniversiteleri ve akademisyenleri ile bir arada çalışmalar yaptık. Yakın döneme kadar \" demir dışı metaller„ kategorisinde değerlendirilen Alüminyum u tüm platformlarda gündem ve konuşulur hale getirdik. Ülkemizde bir fabrika nın devlet eli ile yaptığı yatırımın gelişmesini takip ederek bugün dünyanın 10. Büyük üretim kapasitesine sahip ülkesi olmaya kadar olan tüm serüvende bir şekilde yer aldık. Boksit madeni ile başlayarak nitelikli Alüminyum ürünlerin oluşmasına kadar olan tüm sürece hâkim olan kadromuz özellikle son 20 yıldır yapılan yatırımlara makine ekipman, personel, idari ve kurumsal tüm alanlarda yönlendirici olmuştur. Doğru yatırım, doğru makine ekipman, doğru personel, doğru proje yatırımları doğru sonuçlara götürdüğü bilgisi ile her zaman bu yol haritasını ön gördük. Günümüzde özellikle Alüminyum metalinin stratejik sektörler olan, savunma, otomotiv, havacılık, raylı sistemler, uzay sanayinde kullanım alanları ve bu alanların genişletilmesi. Bu alanlara özel ürünlerin üretilebileceği hatların kurulması veya mevcut üretim hatlarının bu konulara uygun hale getirilmesi sizlere sunacağımız hizmetler içerisindedir. Hammadde üretiminden, mamul ürüne uzanan bu yol haritasında özellikle enerji kullanımı, üretim hızı, kalite ve yeşil üretime uygun proseslerin oluşturulması yine şirketimiz uzmanlık konuları arasındadır. Önümüzdeki süreçte planlanan yatırım ve mevcut yatırımların rehabilitasyonu konularında sizlere sunacağımız hizmet detaylarına şirketimiz faaliyetlerini inceleyerek ulaşabilirsiniz. Planlama, Tasarım, satın alma, kurulum, işletmeye alma, programlama, tüm idari süreçler için uzman kadrolar ile sizlerin hizmetindeyiz."
      },
      services: {
        title: "Gelişiyoruz",
        titleAnd: "ve",
        titleBuild: "İnşa Ediyoruz",
        items: [
          {
            icon: "flaticon-optimization",
            title: "Makina Tedariği",
            description: "Maco Makina, Alüminyum üretim tesisinde Alüminyum döküm, profil, levha, yüzey işlem ve ısıl işlem hatlarının makina ve ekipmanların tedariğini sağlamaktadır."
          },
          {
            icon: "flaticon-design-tools",
            title: "Test Kurulumu",
            description: "Maco Makina, Alüminyum üretim tesisindeki Alüminyum döküm, profil, levha, yüzey işlem ve ısıl işlem hatlarının entegre olarak çalışması ve sistemin kurulmasını sağlar."
          },
          {
            icon: "flaticon-analytics",
            title: "Danışmanlık",
            description: "Maco Makina, Alüminyum üretim tesisinde Alüminyum döküm, profil, levha, yüzey işlem ve ısıl işlem hatlarının makina ve ekipmanların tedariğini sağlamaktadır."
          }
        ]
      }
    }  
  },
  en: {
    // Services
    services: [
      {
        ID: 1,
        OrderNo: "01",
        IconName: "flaticon-worker",
        ServiceName: "Production Consulting",
        ServiceContent: "We optimize your production processes and increase your efficiency."
      },
      {
        ID: 2,
        OrderNo: "02",
        IconName: "flaticon-factory-1",
        ServiceName: "Facility Setup",
        ServiceContent: "We build modern and efficient production facilities."
      },
      {
        ID: 3,
        OrderNo: "03",
        IconName: "flaticon-settings",
        ServiceName: "Machine Engineering",
        ServiceContent: "We provide custom machine design and manufacturing services."
      },
      {
        ID: 4,
        OrderNo: "04",
        IconName: "flaticon-gear",
        ServiceName: "Quality Control",
        ServiceContent: "Control systems that guarantee product quality."
      },
      {
        ID: 5,
        OrderNo: "05",
        IconName: "flaticon-wrench",
        ServiceName: "Maintenance Services",
        ServiceContent: "Regular maintenance services for your machines and equipment."
      },
      {
        ID: 6,
        OrderNo: "06",
        IconName: "flaticon-optimization",
        ServiceName: "Technical Support",
        ServiceContent: "24/7 technical support and consulting services."
      },
      {
        ID: 7,
        OrderNo: "07",
        IconName: "flaticon-helicopter",
        ServiceName: "Steel and Aluminum Helicopter Pads",
        ServiceContent: "Safe and durable helicopter pad solutions for airports and private facilities."
      }
    ],
    // Company information
    companyInfo: {
      name: "Maco Makina",
      tagline: "Committed to High Quality",
      description: "From raw material production to finished products, creating processes suitable for energy use, production speed, quality and green production is among our company's areas of expertise.",
      address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
      phone: "0 (212) 224 41 15",
      email: "info@macomakina.com.tr",
      website: "https://macomakina.com.tr/"
    },
    // Menu items
    menu: {
      home: "Home",
      about: "About Us",
      services: "Our Services",
      products: "Products",
      contact: "Contact",
      portfolio: "Portfolio",
      // Sub menus
      subMenus: {
        products: [
          { name: "PuraDyn Filter System", link: "/urun/1" },
          { name: "PuraDyn MTS-40", link: "/urun/2" },
          { name: "PuraDYN MTS-60", link: "/urun/3" },
          { name: "PuraDYN MTS-240", link: "/urun/4" }
        ],
        services: [
          { name: "Machine Supply", link: "/" },
          { name: "Test Installation", link: "/" },
          { name: "Consulting", link: "/" }
        ]
      }
    },
    // General texts
    texts: {
      ourServices: "Our Services",
      contactInfo: "Contact Information",
      aboutUs: "About Us",
      readMore: "Read More",
      address: "address",
      phone: "phone",
      email: "e-mail",
      projects: "Our Projects",
      blog: "Blog",
      testimonials: "Customer Reviews",
      home: "Home",
      about: "About Us",
      services: "Our Services",
      products: "Products",
      contact: "Contact",
      portfolio: "Portfolio"
    },
    // Home page slider content
    homeSlider: [
      {
        image: "main-slider/heliport-1.png",
        title: "Aluminum and Steel Helicopter Pads"
      },
      {
        image: "main-slider/Maco-Banner01.png",
        title: "Complete Solution for Aluminum Projects"
      },
      {
        image: "main-slider/Maco-Banner02.jpg",
        title: "Quality Approach in Service"
      }
    ],
    // Contact page content
    contact: {
      formTitle: "Contact Us",
      formFields: {
        name: "Full Name",
        phone: "Phone",
        email: "E-mail",
        message: "Your Message"
      },
      submitButton: "Contact Us",
      contactInfo: {
        addressTitle: "Company Address",
        address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
        emailTitle: "E-mail",
        phoneTitle: "Phone Numbers",
        emails: [
          "info@alcometal.com.tr",
          "info@macomakina.com.tr"
        ],
        phones: [
          "+90 212 224 41 15",
          "+90 212 224 41 16"
        ]
      }
    },
    // About page content
    about: {
      pageTitle: "About Us",
      breadcrumb: {
        home: "Home",
        about: "About Us"
      },
      story: {
        label: "OUR STORY",
        title: "In Turkey's Metal sector",
        titleLine2: "We have been serving",
        titleLine3: "for over 50 years",
        since: "since 1972",
        subtitle: "With a forward-looking structure and experience, we have determined how important and strategic Aluminum will be for our country in the near future.",
        description: "We followed the studies conducted in the world simultaneously. We worked together with our country's universities and academics. We brought Aluminum, which was evaluated in the \"non-ferrous metals\" category until the recent period, to the agenda and made it a topic of discussion on all platforms. We have been involved in some way in the entire adventure from following the development of an investment made by a factory in our country with the hand of the state to becoming the 10th largest production capacity country in the world today. Our staff, who have mastered the entire process from bauxite mining to the formation of qualified Aluminum products, has been guiding in all areas of machine equipment, personnel, administrative and corporate, especially in investments made in the last 20 years. We have always foreseen this roadmap with the knowledge that the right investment, the right machine equipment, the right personnel, and the right project investments lead to the right results. Today, especially the use of Aluminum metal in strategic sectors such as defense, automotive, aviation, rail systems, space industry, and the expansion of these areas. The establishment of lines that can produce products specific to these areas or the adaptation of existing production lines to these topics is among the services we will offer you. In this roadmap extending from raw material production to finished products, especially the creation of processes suitable for energy use, production speed, quality and green production is among our company's areas of expertise. You can reach the service details we will offer you regarding the planned investments and the rehabilitation of existing investments in the upcoming process by examining our company's activities. We are at your service with expert staff for planning, design, procurement, installation, commissioning, programming, and all administrative processes."
      },
      services: {
        title: "We Are Growing",
        titleAnd: "and",
        titleBuild: "Building",
        items: [
          {
            icon: "flaticon-optimization",
            title: "Machine Supply",
            description: "Maco Makina provides the supply of machinery and equipment for aluminum casting, profile, sheet, surface treatment and heat treatment lines in aluminum production facilities."
          },
          {
            icon: "flaticon-design-tools",
            title: "Test Installation",
            description: "Maco Makina ensures the integrated operation and system installation of aluminum casting, profile, sheet, surface treatment and heat treatment lines in aluminum production facilities."
          },
          {
            icon: "flaticon-analytics",
            title: "Consulting",
            description: "Maco Makina provides consulting services for aluminum production facilities, covering all aspects from planning to commissioning."
          }
        ]
      }
    }
  },
  de: {
    // Dienstleistungen
    services: [
      {
        ID: 1,
        OrderNo: "01",
        IconName: "flaticon-worker",
        ServiceName: "Produktionsberatung",
        ServiceContent: "Wir optimieren Ihre Produktionsprozesse und steigern Ihre Effizienz."
      },
      {
        ID: 2,
        OrderNo: "02",
        IconName: "flaticon-factory-1",
        ServiceName: "Anlageneinrichtung",
        ServiceContent: "Wir bauen moderne und effiziente Produktionsanlagen."
      },
      {
        ID: 3,
        OrderNo: "03",
        IconName: "flaticon-settings",
        ServiceName: "Maschinenbau",
        ServiceContent: "Wir bieten kundenspezifische Maschinenkonstruktion und Fertigung."
      },
      {
        ID: 4,
        OrderNo: "04",
        IconName: "flaticon-gear",
        ServiceName: "Qualitätskontrolle",
        ServiceContent: "Kontrollsysteme, die die Produktqualität garantieren."
      },
      {
        ID: 5,
        OrderNo: "05",
        IconName: "flaticon-wrench",
        ServiceName: "Wartungsdienste",
        ServiceContent: "Regelmäßige Wartungsdienste für Ihre Maschinen und Ausrüstungen."
      },
      {
        ID: 6,
        OrderNo: "06",
        IconName: "flaticon-optimization",
        ServiceName: "Technischer Support",
        ServiceContent: "24/7 technischer Support und Beratungsdienste."
      },
      {
        ID: 7,
        OrderNo: "07",
        IconName: "flaticon-helicopter",
        ServiceName: "Aluminium- und Stahl-Helikopterlandeplätze",
        ServiceContent: "Sichere und langlebige Helikopterlandeplatz-Lösungen für Flughäfen und private Einrichtungen."
      }
    ],
    // Firmeninformationen
    companyInfo: {
      name: "Maco Makina",
      tagline: "Verpflichtet zu hoher Qualität",
      description: "Von der Rohstoffproduktion bis zu Fertigprodukten gehört die Schaffung von Prozessen, die für Energieverbrauch, Produktionsgeschwindigkeit, Qualität und grüne Produktion geeignet sind, zu den Fachbereichen unseres Unternehmens.",
      address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
      phone: "0 (212) 224 41 15",
      email: "info@macomakina.com.tr",
      website: "https://macomakina.com.tr/"
    },
    // Menüelemente
    menu: {
      home: "Startseite",
      about: "Über uns",
      services: "Unsere Dienstleistungen",
      products: "Produkte",
      contact: "Kontakt",
      portfolio: "Portfolio",
      // Untermenüs
      subMenus: {
        products: [
          { name: "PuraDyn Filtersystem", link: "/urun/1" },
          { name: "PuraDyn MTS-40", link: "/urun/2" },
          { name: "PuraDYN MTS-60", link: "/urun/3" },
          { name: "PuraDYN MTS-240", link: "/urun/4" }
        ],
        services: [
          { name: "Maschinenlieferung", link: "/" },
          { name: "Testinstallation", link: "/" },
          { name: "Beratung", link: "/" }
        ]
      }
    },
    // Allgemeine Texte
    texts: {
      ourServices: "Unsere Dienstleistungen",
      contactInfo: "Kontaktinformationen",
      aboutUs: "Über uns",
      readMore: "Mehr lesen",
      address: "Adresse",
      phone: "Telefon",
      email: "E-Mail",
      projects: "Unsere Projekte",
      blog: "Blog",
      testimonials: "Kundenbewertungen",
      home: "Startseite",
      about: "Über uns",
      services: "Unsere Dienstleistungen",
      products: "Produkte",
      contact: "Kontakt",
      portfolio: "Portfolio"
    },
    // Startseite Slider-Inhalte
    homeSlider: [
      {
        image: "main-slider/Maco-Banner01.png",
        title: "Komplette Lösung für Aluminiumprojekte"
      },
      {
        image: "main-slider/Maco-Banner02.jpg",
        title: "Qualitätsansatz im Service"
      },
      {
        image: "main-slider/heliport-1.png",
        title: "Stahl- und Aluminium-Helikopterlandeplätze"
      }
    ],
    // Kontaktseite Inhalte
    contact: {
      formTitle: "Kontaktieren Sie uns",
      formFields: {
        name: "Vollständiger Name",
        phone: "Telefon",
        email: "E-Mail",
        message: "Ihre Nachricht"
      },
      submitButton: "Kontaktieren Sie uns",
      contactInfo: {
        addressTitle: "Firmenadresse",
        address: "Hürriyet Mah. Dr. Cemil Bengü Cad. No:24/A 34403 Çağlayan Kağıthane İstanbul",
        emailTitle: "E-Mail",
        phoneTitle: "Telefonnummern",
        emails: [
          "info@alcometal.com.tr",
          "info@macomakina.com.tr"
        ],
        phones: [
          "+90 212 224 41 15",
          "+90 212 224 41 16"
        ]
      }
    },
    // Über uns Seite Inhalte
    about: {
      pageTitle: "Über uns",
      breadcrumb: {
        home: "Startseite",
        about: "Über uns"
      },
      story: {
        label: "UNSERE GESCHICHTE",
        title: "Im türkischen Metallsektor",
        titleLine2: "dienen wir seit",
        titleLine3: "über 50 Jahren",
        since: "seit 1972",
        subtitle: "Mit einer zukunftsorientierten Struktur und Erfahrung haben wir bestimmt, wie wichtig und strategisch Aluminium für unser Land in naher Zukunft sein wird.",
        description: "Wir haben die weltweit durchgeführten Studien zeitgleich verfolgt. Wir haben mit den Universitäten und Akademikern unseres Landes zusammengearbeitet. Wir haben Aluminium, das bis in die jüngste Zeit in die Kategorie \"Nichteisenmetalle\" eingestuft wurde, auf allen Plattformen zum Thema gemacht und es zum Gesprächsthema gemacht. Wir waren auf die eine oder andere Weise an dem gesamten Abenteuer beteiligt, von der Verfolgung der Entwicklung einer Investition, die eine Fabrik in unserem Land mit staatlicher Hand getätigt hat, bis hin zur Erlangung der 10. größten Produktionskapazität der Welt heute. Unser Personal, das den gesamten Prozess von der Bauxitmine bis zur Entstehung qualifizierter Aluminiumprodukte beherrscht, war in den letzten 20 Jahren in allen Bereichen von Maschinenausrüstung, Personal, Verwaltung und Unternehmensführung richtungsweisend. Wir haben diese Roadmap immer mit dem Wissen vorausgesehen, dass die richtige Investition, die richtige Maschinenausrüstung, das richtige Personal und die richtigen Projektinvestitionen zu den richtigen Ergebnissen führen. Heute, insbesondere die Verwendung von Aluminiummetall in strategischen Sektoren wie Verteidigung, Automobil, Luftfahrt, Schienensysteme, Raumfahrtindustrie und die Erweiterung dieser Bereiche. Die Einrichtung von Linien, die produktspezifische Produkte für diese Bereiche produzieren können, oder die Anpassung bestehender Produktionslinien an diese Themen gehört zu den Dienstleistungen, die wir Ihnen anbieten werden. In dieser Roadmap, die sich von der Rohstoffproduktion bis zu Fertigprodukten erstreckt, gehört insbesondere die Schaffung von Prozessen, die für Energieverbrauch, Produktionsgeschwindigkeit, Qualität und grüne Produktion geeignet sind, zu den Fachbereichen unseres Unternehmens. Sie können die Dienstleistungsdetails, die wir Ihnen in Bezug auf geplante Investitionen und die Rehabilitation bestehender Investitionen im kommenden Prozess anbieten werden, erreichen, indem Sie die Aktivitäten unseres Unternehmens untersuchen. Wir stehen Ihnen mit Expertenteams für Planung, Design, Beschaffung, Installation, Inbetriebnahme, Programmierung und alle administrativen Prozesse zur Verfügung."
      },
      services: {
        title: "Wir wachsen",
        titleAnd: "und",
        titleBuild: "bauen",
        items: [
          {
            icon: "flaticon-optimization",
            title: "Maschinenlieferung",
            description: "Maco Makina liefert Maschinen und Ausrüstungen für Aluminiumguss-, Profil-, Blech-, Oberflächenbehandlungs- und Wärmebehandlungslinien in Aluminiumproduktionsanlagen."
          },
          {
            icon: "flaticon-design-tools",
            title: "Testinstallation",
            description: "Maco Makina gewährleistet den integrierten Betrieb und die Systeminstallation von Aluminiumguss-, Profil-, Blech-, Oberflächenbehandlungs- und Wärmebehandlungslinien in Aluminiumproduktionsanlagen."
          },
          {
            icon: "flaticon-analytics",
            title: "Beratung",
            description: "Maco Makina bietet Beratungsdienste für Aluminiumproduktionsanlagen, die alle Aspekte von der Planung bis zur Inbetriebnahme abdecken."
          }
        ]
      }
    }
  }
};

// Dil verileri
export const languages = [
  { 
    ID: '0', 
    LanguageIconName: 'tr', 
    LanguageName: 'Türkçe',
    flag: '/flags/tr.svg',
    code: 'tr'
  },
  { 
    ID: '1', 
    LanguageIconName: 'gb', 
    LanguageName: 'English',
    flag: '/flags/gb.svg',
    code: 'en'
  },
  { 
    ID: '2', 
    LanguageIconName: 'de', 
    LanguageName: 'Deutsch',
    flag: '/flags/de.svg',
    code: 'de'
  }
];

// İletişim formu ayarları
export const contactSettings = {
  emailService: {
    serviceId: 'service_0btii1e',
    templateId: 'template_xpxhqtc',
    publicKey: 'yWrf5DHaT0GPYpKtI',
    toEmail: 'omurcanuslu@outlook.com'
  },
  fileUpload: {
    enabled: false, // Statik sitede dosya yükleme devre dışı
    message: "Dosya yükleme özelliği statik sitede kullanılamaz"
  }
};

// Sosyal medya linkleri
export const socialLinks = {
  facebook: "https://facebook.com/macoendustri",
  twitter: "https://twitter.com/macoendustri",
  linkedin: "https://linkedin.com/company/macoendustri",
  instagram: "https://instagram.com/macoendustri",
  youtube: "https://youtube.com/macoendustri"
};

// Site ayarları
export const siteSettings = {
  defaultLanguage: 'tr',
  supportedLanguages: ['tr', 'en', 'de'],
  theme: {
    primaryColor: '#007bff',
    secondaryColor: '#6c757d'
  }
};

// Dil değiştirme yardımcı fonksiyonu
export const getContentByLanguage = (language = 'tr') => {
  return content[language] || content.tr;
};

// Mevcut dil için içerik al
export const getCurrentContent = () => {
  const savedLanguage = localStorage.getItem('selectedCountry');
  const languageCode = languages.find(lang => lang.ID === savedLanguage)?.code || 'tr';
  return getContentByLanguage(languageCode);
};